/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S3_MetaInputs */

const en_mk_abt_s3_meta = /** @type {(inputs: Mk_Abt_S3_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet`)
};

const id_mk_abt_s3_meta = /** @type {(inputs: Mk_Abt_S3_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum`)
};

/**
* | output |
* | --- |
* | "Not yet" |
*
* @param {Mk_Abt_S3_MetaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s3_meta = /** @type {((inputs?: Mk_Abt_S3_MetaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S3_MetaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s3_meta(inputs)
	return en_mk_abt_s3_meta(inputs)
});